// Uploads a contractbatch CSV and shows what happened per line. The file is read on the
// server; rejected lines come back as a file with a comment column to correct and resend.
document.addEventListener('DOMContentLoaded', function () {
    const panel = document.querySelector('#contract-batch-import');
    if (!panel) {
        return;
    }

    const button = panel.querySelector('#contract-batch-import-button');
    const file = panel.querySelector('#contract-batch-import-file');
    const spinner = panel.querySelector('#contract-batch-import-spinner');
    const message = panel.querySelector('#contract-batch-import-message');

    /**
     * @returns {string} the CSRF token, or empty when the meta tag is gone
     */
    function csrfToken() {
        const meta = document.querySelector('meta[name="csrf-token"]');
        return meta ? meta.content : '';
    }

    /**
     * @param {boolean} isBusy - whether the upload is running
     */
    function busy(isBusy) {
        button.disabled = isBusy;
        spinner.hidden = !isBusy;
    }

    /**
     * Remove the flash of an earlier import: it survived the reload it came with and
     * would sit above this answer saying something else.
     */
    function clearFlash() {
        document.querySelectorAll('.header-flash-message').forEach(function (flash) {
            const wrap = flash.closest('.header-flash-message-wrap') || flash;
            (wrap.parentElement && wrap.parentElement.classList.contains('row') ? wrap.parentElement : wrap).remove();
        });
    }

    /**
     * @param {string} text - the message to show, empty to clear it
     */
    function fill(text) {
        message.textContent = '';
        message.className = 'contract-batch-import-message';
        if (text) {
            message.textContent = text;
        }
    }

    /**
     * @param {string} [text] - the failure to show; falls back to the generic one
     */
    function showFailure(text) {
        fill(text || message.dataset.failed || '');
        message.className = 'contract-batch-import-message invalid-feedback d-block';
    }

    /**
     * Report what the import did, per line where there is something to read.
     *
     * @param {{imported: number, skipped: number, failed: number, errors: Object<string, string>,
     *          reload: boolean, download: string}} data - the server's answer
     */
    function showResult(data) {
        // nothing to correct: straight into the list, where the new rows are. The count
        // comes back as a flash message, so it survives the reload.
        if (data.reload) {
            window.location.reload();
            return;
        }

        fill((message.dataset.result || '')
            .replace(':imported', data.imported)
            .replace(':skipped', data.skipped)
            .replace(':failed', data.failed));

        const lines = Object.keys(data.errors || {});
        if (lines.length) {
            const list = document.createElement('ul');
            list.className = 'contract-batch-import-errors';
            lines.forEach(function (line) {
                const item = document.createElement('li');
                // textContent, because the message carries values from the file itself
                item.textContent = (message.dataset.line || '').replace(':line', line) + ' ' + data.errors[line];
                list.appendChild(item);
            });
            message.appendChild(list);
        }

        if (data.download) {
            const link = document.createElement('a');
            link.href = data.download;
            link.textContent = message.dataset.download || '';
            message.appendChild(document.createElement('br'));
            message.appendChild(link);
        }

        // rows that did land are not in the list yet, and reloading here would take the
        // errors with it - so the choice is left to whoever is reading them. Skipped rows
        // are already in the list, so they are no reason to offer it.
        if (data.imported) {
            const refresh = document.createElement('button');
            refresh.type = 'button';
            refresh.className = 'btn btn-link contract-batch-import-refresh';
            refresh.textContent = message.dataset.refresh || '';
            refresh.addEventListener('click', function () {
                window.location.reload();
            });
            message.appendChild(document.createElement('br'));
            message.appendChild(refresh);
        }
    }

    button.addEventListener('click', function () {
        file.click();
    });

    file.addEventListener('change', function () {
        if (!file.files.length) {
            return;
        }

        const data = new FormData();
        data.append('file', file.files[0]);

        busy(true);
        clearFlash();
        fill(button.dataset.busy || '');

        fetch(panel.dataset.importUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': csrfToken(),
            },
            body: data,
        }).then(function (response) {
            return response.json().catch(function () {
                return null;
            });
        }).then(function (result) {
            busy(false);
            // the field keeps the old file otherwise, and picking the same one again
            // would not fire a change event
            file.value = '';

            if (!result) {
                showFailure('');
                return;
            }

            if (result.message) {
                showFailure(result.message + ((result.details && result.details.length) ? ' ' + result.details.join(', ') : ''));
                return;
            }

            showResult(result);
        }).catch(function () {
            busy(false);
            file.value = '';
            showFailure('');
        });
    });
});
